import { z } from 'zod';

export const repeatedQuestionnaireFilloutStatusResDto = z.object({
  sf12: z.boolean(),
  cudit: z.boolean(),
});

export type RepeatedQuestionnaireFilloutStatusResDto = z.infer<
  typeof repeatedQuestionnaireFilloutStatusResDto
>;
